/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import AsiaTerritories from "./asia";
import ErupeTerritories from "./erupe";
import AfricaTerritories from "./africa";
import AustraliaTerritories from "./australia";
import NorthTerritories from "./north-america";
import AntarticaTerritories from "./antartica";
import SouthAmericaTerritories from "./south-america";
import { useSelector } from "react-redux";
import { ReleaseState, StoreState } from "@type/models/store";
import { REACT_IMAGE_URL } from "../../../constants";

interface territoriesInterface {
  all: string[];
  asia: string[];
  europe: string[];
  africa: string[];
  australia: string[];
  northAmerica: string[];
  antartica: string[];
  southAmerica: string[];
}

interface Props {
  handleSubmission: (field: string, data: territoriesInterface) => void;
  callFunction: boolean;
  clearForm: boolean;
}

let initialTerritories = {
  all: [],
  asia: [],
  europe: [],
  africa: [],
  australia: [],
  northAmerica: [],
  antartica: [],
  southAmerica: [],
};
const wwTerritoriesIds = ["ZZ"];

const Territories: React.FC<Props> = ({
  handleSubmission,
  callFunction,
  clearForm,
}) => {
  const [countriesCheck, setCountriesCheck] = useState<any>(false);
  const { releaseInfo } = useSelector(
    (state: ReleaseState) => state.releaseInfo
  );
  const territories = useSelector(
    (state: StoreState) => state.suggestion.territories
  );
  const [selectedTerritories, setSelectedTerritories] =
    useState<territoriesInterface>(initialTerritories);

  const handleAllCheckAll = () => {
    setCountriesCheck("countriesCheck");
  };

  const handleAllUncheckAll = () => {
    setCountriesCheck(!countriesCheck);
  };

  const handleWorldwideCheckboxChange = () => {
    const wwTerritories = territories.filter((country: any) =>
      wwTerritoriesIds.includes(country.code_alpha2)
    );

    if (selectedTerritories.all.includes(wwTerritories[0].id)) {
      setSelectedTerritories((prevSelected) => ({
        ...prevSelected,
        all: [],
      }));
    } else {
      handleAllUncheckAll();
      setSelectedTerritories((prevSelected) => ({
        ...prevSelected,
        all: [...prevSelected.all, wwTerritories[0].id],
        asia: [],
        europe: [],
        africa: [],
        australia: [],
        northAmerica: [],
        antartica: [],
        southAmerica: [],
      }));
    }
    document
      .getElementById("territories_validation_alert")
      ?.style.setProperty("display", "none");
  };

  const handleSetSelectedTerritories = (
    continent: string,
    selectedTerritory: string[]
  ) => {
    if (selectedTerritory.length > 0) {
      setSelectedTerritories((prevSelected) => ({
        ...prevSelected,
        all: [],
      }));
    }
    setSelectedTerritories((prevSelected) => ({
      ...prevSelected,
      [continent]: selectedTerritory,
    }));
    document
      .getElementById("territories_validation_alert")
      ?.style.setProperty("display", "none");
  };

  const handleSubmit = () => {
    const hasSelectedTerritories = Object.values(selectedTerritories).some(
      (regionTerritories) => regionTerritories.length > 0
    );
    document
      .getElementById("territories_validation_alert")
      ?.style.setProperty("display", "none");

    if (hasSelectedTerritories) {
      localStorage.setItem(
        "selectedTerritories",
        JSON.stringify(selectedTerritories)
      );
      handleSubmission("territories", selectedTerritories);
    } else {
      document
        .getElementById("territories_validation_alert")
        ?.style.setProperty("display", "inline-block");
    }
  };

  useEffect(() => {
    if (callFunction) {
      handleSubmit();
    }
  }, [callFunction]);

  useEffect(() => {
    setSelectedTerritories(initialTerritories);
    handleAllUncheckAll();
    setCountriesCheck(false);
  }, [clearForm]);

  useEffect(() => {
    const storedTerritories = localStorage.getItem("selectedTerritories");
    if (storedTerritories) {
      setSelectedTerritories(JSON.parse(storedTerritories));
    }
  }, []);

  useEffect(() => {
    if (releaseInfo?.countryInfo?.countryId.length > 0) {
      const selectedTerritories = releaseInfo.countryInfo.countryId
        .map((selectedCountry: any) =>
          territories.find(
            (territory) =>
              selectedCountry.country_id === territory.id &&
              wwTerritoriesIds.includes(territory.code_alpha2)
          )
        )
        .filter(Boolean);

      setSelectedTerritories((prevSelected) => ({
        ...prevSelected,
        all: selectedTerritories.map((t: any) => t.id),
        asia: [],
        europe: [],
        africa: [],
        australia: [],
        northAmerica: [],
        antartica: [],
        southAmerica: [],
      }));
    }
  }, [releaseInfo?.countryInfo]);

  return (
    <div className="page page-label px-5">
      <div className="row col-12">
        <div className="col-md-6 my-4">
          <div
            className="alert alert-danger my-4 "
            id="territories_validation_alert"
            role="alert"
            style={{ display: "none", textAlign: "left" }}
          >
            Please select at least one country.
          </div>
        </div>
      </div>
      <div className="row col-12">
        <div className="custom-control custom-checkbox round-checkbox mb-2 relative block min-h-6 pl-6">
          <label className="custom-control-label flex items-center text-center align-content-center     display-block">
            <div className="w-6 h-6 mr-2   rounded-full flex-shrink-0">
              <input
                type="checkbox"
                className="rounded-full h-8 w-8 cursor-pointer bg-red-100 border-red-300 text-red-600 focus:ring-red-200"
                checked={selectedTerritories.all.length > 0}
                onChange={() => handleWorldwideCheckboxChange()}
              />
            </div>
            <img
              src={`${REACT_IMAGE_URL}/static/images/flags/ww.svg`}
              className="w-1/10 h-1 align-middle border-none"
              style={{
                width: "2%",
                height: "2%",
                margin: "0px 5px",
              }}
            />
            <span>&nbsp;Worldwide</span>
          </label>
        </div>
        <div className="flex">
          <AsiaTerritories
            countriesCheck={countriesCheck}
            onSetSelectedTerritories={(
              continent: string,
              selectedCountries: string[]
            ) => handleSetSelectedTerritories(continent, selectedCountries)}
          />
          <ErupeTerritories
            countriesCheck={countriesCheck}
            onSetSelectedTerritories={(
              continent: string,
              selectedCountries: string[]
            ) => handleSetSelectedTerritories(continent, selectedCountries)}
          />
          <AfricaTerritories
            countriesCheck={countriesCheck}
            onSetSelectedTerritories={(
              continent: string,
              selectedCountries: string[]
            ) => handleSetSelectedTerritories(continent, selectedCountries)}
          />
          <AustraliaTerritories
            countriesCheck={countriesCheck}
            onSetSelectedTerritories={(
              continent: string,
              selectedCountries: string[]
            ) => handleSetSelectedTerritories(continent, selectedCountries)}
          />
        </div>
        <div className="flex justify-content-between">
          <NorthTerritories
            countriesCheck={countriesCheck}
            onSetSelectedTerritories={(
              continent: string,
              selectedCountries: string[]
            ) => handleSetSelectedTerritories(continent, selectedCountries)}
          />
          <AntarticaTerritories
            countriesCheck={countriesCheck}
            onSetSelectedTerritories={(
              continent: string,
              selectedCountries: string[]
            ) => handleSetSelectedTerritories(continent, selectedCountries)}
          />
          <SouthAmericaTerritories
            countriesCheck={countriesCheck}
            onSetSelectedTerritories={(
              continent: string,
              selectedCountries: string[]
            ) => handleSetSelectedTerritories(continent, selectedCountries)}
          />
        </div>
      </div>
      <div className="subsection-title my-1em">
        <div className="flex font-1rem my-2">
          <a className="flex mx-1" href="#" onClick={handleAllCheckAll}>
            Check all
          </a>
          {" "}
          {" "}
          <a className="flex mx-1" href="#" onClick={handleAllUncheckAll}>
            Uncheck all
          </a>
        </div>
      </div>
    </div>
  );
};

export default Territories;
